var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{staticClass:"bg-white",attrs:{"view":"hHh lpR fFf"}},[_c('q-page-container',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }